import { Pipe, PipeTransform } from "@angular/core";
import { OrderPaymentStatusEnum } from "@models/order";

@Pipe({
  name: "orderPaymentStatusClass",
  standalone: true,
})
export class OrderPaymentStatusClassPipe implements PipeTransform {
  transform(value: OrderPaymentStatusEnum | string): string {
    switch (value) {
      case OrderPaymentStatusEnum.Paid:
      case OrderPaymentStatusEnum.Courtesy:
      case OrderPaymentStatusEnum.Transferred:
        return "success";

      case OrderPaymentStatusEnum.Canceled:
      case OrderPaymentStatusEnum.Expired:
      case OrderPaymentStatusEnum.Failed:
      case OrderPaymentStatusEnum.Refused:
      case OrderPaymentStatusEnum.RefundRejected:
        return "error";

      case OrderPaymentStatusEnum.WaitingPayment:
      case OrderPaymentStatusEnum.Pending:
      case OrderPaymentStatusEnum.Processing:
      case OrderPaymentStatusEnum.RefundRequested:
        return "pending";

      case OrderPaymentStatusEnum.Refunded:
        return "warning";

      default:
        return "warning";
    }
  }
}
